export const MIN_PASSWORD_STRENGTH_SCORE = 1;
export const DEFAULT_PASSWORD_LENGTH = 8;
export const DEFAULT_EXPIRY_PERIOD = 7;
export const COPY_COOLDOWN = 2000;